import StepNavBar from 'src/components/StepNavBar';
import useAttachDocument from 'src/hooks/useAttachDocument';
import useEnterReceipts from 'src/hooks/useEnterReceipts';

const EnterReceiptNavBar = () => {
  const {
    goToPrevStep,
    disableStep,
    showPreview,
    setShowPreview,
    guideMe,
    nextStep,
    currentStep,
    setStep,
    setSearchPo,
    setSupplierSearch,
    setLineItemSearch,
    buttonRef,
  } = useEnterReceipts();

  const { count } = useAttachDocument();

  const onCompanyChange = () => {
    setStep(1);
    setSearchPo((prev) => ({ ...prev, value: '' }));
    setSupplierSearch('');
    setLineItemSearch('');
  };

  return (
    <StepNavBar
      prevStep={goToPrevStep}
      nextStep={nextStep}
      disableStep={disableStep}
      GuideMe={guideMe}
      docCount={count}
      showPreview={showPreview}
      setShowPreview={setShowPreview}
      nextButtonRef={buttonRef}
      hideBackButton={currentStep > 1}
      onCompanyChange={onCompanyChange}
    />
  );
};

export default EnterReceiptNavBar;
